export const DEFAULT_MFA_SETTINGS = {
  isSmsEnabled: false,
  isTotpEnabled: false,
  preferredOption: null,
}
